import Resource from '../Resource'

class CommonCaseTypeServices extends Resource {
    /**
    * @deprecated You must use the new service that is located in "common/case-types/case-types.service.ts"
    */
    async getActiveCaseTypesByLaboratory(laboratoryId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/caseTypes`)
        return response.data
    }

    /**
    * @deprecated You must use the new service that is located in "common/case-types/case-types.service.ts"
    */
    async getCaseTypes() {
        const response = await this.axios.get(`/common/laboratories/caseTypes`)
        return response.data
    }
}

export default new CommonCaseTypeServices()
